import {
  getTypeOrNull,
  useAccountSetupQuery,
} from '@spotify/confidence-graphql';

import { extractLastNameComponent } from '../utils';

const WEBSITE_LINK = 'https://confidence.spotify.com';

export function useConfidenceUrl(route: string) {
  const { data } = useAccountSetupQuery({ fetchPolicy: 'cache-first' });
  const user = getTypeOrNull(data?.currentUser);
  const currentAccount = user?.account
    ? extractLastNameComponent(user.account)
    : undefined;

  const url = new URL(WEBSITE_LINK + route);

  if (currentAccount) {
    url.searchParams.set('login', 'true');
    url.searchParams.set('organization', currentAccount);
  }

  return url;
}
